<template>
     <div class="home-page__recipes" v-if="featuredRecipes.length > 0">        
            <div class="container-xl">
                <div class="main-page-block">
                    <div class="row">
                        <div class="col-12">
                            <h3>{{lang('suss_fozz_az_univerrel')}}</h3>
                        </div>
                    </div>
                    <div class="row home-page__recipes-content">
                        <div class="col-12 col-md-6 col-lg-4" >                        
                            <RecipeItem v-if="mainFeaturedRecipe != null"
                                :name="mainFeaturedRecipe.name"
                                :id="mainFeaturedRecipe.id" 
                                :srcset="itemSrcset(mainFeaturedRecipe)" 
                                :src="itemSrc(mainFeaturedRecipe, 'w640h493')" 
                                :difficulty="mainFeaturedRecipe.difficulty"
                                :dish="mainFeaturedRecipe.dish"
                                :making_time="mainFeaturedRecipe.making_time" 
                                :recipe_slug="mainFeaturedRecipe.slug" 
                            />                            
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 home-page__recipes-little-wrap">                        
                            <RecipeItemLittle v-for="(recipe, frecipeindex) in featuredRecipes"                 
                                :key="frecipeindex" 
                                :name="recipe.name"
                                :id="recipe.id"                                  
                                :recipe_slug="recipe.slug" 
                                :srcset="itemSrcset(recipe)" 
                                :src="itemSrc(recipe, 'w640h493')" 
                                :difficulty="recipe.difficulty"
                                :dish="recipe.dish"
                                :making_time="recipe.making_time" 
                            />                           
                        </div>
                        <div class="col-12 col-md-4 col-lg-4 home-page__recipes-banner-wrap">
                            <div class="home-page__recipes-banner" ref="recipes_banner" >
                                <div class="btn-wrap">
                                    <router-link 
                                        :to="{name: 'RecipesCategoryListAll_'+ currentLangName()}" 
                                        class="btn btn--primary">
                                        <span>{{ lang("fooldal_tovabb_a_receptekhez")}}</span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  
</template>

<script>
import axios from 'axios'
import RecipeItem from '@/components/pagesComponents/recipes/RecipeItem.vue'
import RecipeItemLittle from '@/components/pagesComponents/recipes/RecipeItemLittle.vue'

export default {
    data(){
        return{
            featuredRecipes: [],
            mainFeaturedRecipe: null,
            banner: {},
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME           
        }
    },
    components:{
        RecipeItem,
        RecipeItemLittle
    },  
    methods:{
        setFeaturedRecipes(){                                                   
            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/filter/11?relations=1&relations_params[information][where][0][0]=where&relations_params[information][where][0][1]=status&relations_params[information][where][0][2]=1&relations_params[information][order_by][0][0]=sort_order&relations_params[information][order_by][0][1]=asc&relations_params[information][order_by][1][0]=name&relations_params[information][order_by][1][1]=asc',{
            params:{
                "language_id": this.$store.getters.getSelectedLang.id              
            }
            }).then(response => {                
                if (response.data.status == true ){                    
                    if (response.data.filter[0].information){
                        var array = response.data.filter[0].information;
                        for (var i = array.length - 1; i > 0; i--) {
                            var j = Math.floor(Math.random() * (i + 1));
                            var temp = array[i];
                            array[i] = array[j];
                            array[j] = temp;
                        }
                        for ( i = 0; i < array.length && i<4; i++)
                        {
                            this.featuredRecipes.push(array[i]); 
                        }
                        
                        this.setMainFeaturedRecipe()
                        this.setBannerData()
                    } else {
                        this.featuredRecipes = []
                    }
                    
                } else {
                    this.featuredRecipes = []
                }             
            })
            .catch((err) => {
                console.log(err)
            });                
        },
        setMainFeaturedRecipe(){            

            this.mainFeaturedRecipe = this.featuredRecipes[0]
            this.featuredRecipes = this.featuredRecipes.splice(1)
        },
        setBannerData(){
            let _this = this          

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information/280?&where[1][0]=where&where[1][1]=status&where[1][2]=1&select[0]=image',{            
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {                             
                if (response.data.status == true ){
                    _this.banner = response.data.information[0].image  
                    _this.addBannerStyle()               
                } else {
                    _this.banner = {}              
                }                                                          
            })
            .catch((err) => {
                console.log(err)
            });
        },
        addBannerStyle(){
            let banner_url = this.src_url + '/' + this.banner.path + '/' + this.banner.file_name
            let _this = this

            setTimeout(() => {
                _this.$refs.recipes_banner.setAttribute("style", "background-image: url(" + banner_url + ")") 
            }, 100)            
        }
    },
    created(){
        this.setFeaturedRecipes()        
    }
}
</script>